import React, { useEffect, useState } from 'react';
import FirebaseAuth from 'Common/components/FirebaseAuth';
import {
  V1Gateway_RegisterUserMutationVariables,
} from 'Generated/graphql';
import { getCookie, MimoblCookie } from '@bookpeazy/common-js';
import { useFormikContext } from 'formik';
import { EmailAuthProvider, getAuth, GoogleAuthProvider } from 'firebase/auth';
import { AppCookie as Cookies, setCookie } from 'Common/functions/Cookie';
import Bugsnag from '@bugsnag/js';
import TOSCheckbox from 'Common/components/TOSCheckbox';
import NoSSR from 'Common/hoc/NoSSR';
import 'Clients/FireBaseClient';

type FirebaseAuthStageProps = {
  tosChecked: boolean;
  setTosChecked: (checked: boolean) => void;
  copyPrefix?: string;
}

const FirebaseAuthStage: React.FC<FirebaseAuthStageProps> = ({
  tosChecked,
  setTosChecked,
  copyPrefix,
}) => {
  const {
    values,
    setFieldValue,
    submitForm,
    validateForm,
  } = useFormikContext<V1Gateway_RegisterUserMutationVariables>();
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    if (isSubmit) {
      validateForm().then(errs => {
        if (Object.keys(errs).length > 0) {
          console.warn(errs);
        } else {
          submitForm();
        }
      });
    }
  }, [isSubmit]);

  return (
    <div className="">
      <div
        className="my-6"
      >
        <TOSCheckbox
          checked={tosChecked}
          onChange={() => setTosChecked(!tosChecked)}
          tosLink={values.accountType === 1 ?
            'https://bookpeazy.com/terms-of-service-service-provider' :
            'https://bookpeazy.com/peazy-terms-of-service'}
        />
        <div
          className={tosChecked ? '' : 'pointer-events-none'}
        >
          <NoSSR>
            <FirebaseAuth
              className="firebase-auth"
              copyPrefix={copyPrefix}
              uiConfig={{
                signInFlow: 'popup',
                signInOptions: [
                  EmailAuthProvider.PROVIDER_ID,
                  {
                    provider: GoogleAuthProvider.PROVIDER_ID,
                    customParameters: {
                      prompt: 'select_account'
                    }
                  }
                ],
                siteName: 'Peazy',
                callbacks: {
                  signInSuccessWithAuthResult: ({ user }): boolean => {
                    (async (): Promise<void> => {
                      const idToken = await user.getIdToken();
                      const referrer = getCookie(
                        MimoblCookie.USER_REFERRER,
                      );

                      setFieldValue('idToken', idToken);
                      setFieldValue('referrer', referrer);

                      setIsSubmit(true);
                      setCookie(Cookies.PeazyIsLoggedIn, 'true', 3600 * 24 * 14);
                    })();
                    // Return false here to prevent navigation
                    return false;
                  },
                  signInFailure: error => {
                    Bugsnag.notify('Firebase signin error:' + error.toJSON());
                  },
                }
              }}
              firebaseAuth={getAuth()}
            />
          </NoSSR>
        </div>
      </div>
    </div>
  );
};

export default FirebaseAuthStage;
